// REQUIRED IMPORTS
const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import _ from "underscore";
import moment from "moment";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import orgInfoDetails from "./html/orgDetails/orgInfoDetails.html";
import { createPreventDefault, isPresent,formatPhone} from '../../utilities/general';
import {
    setElementsFromScope
} from "../../utilities/selectorHelpers";
import PagableComponent from '../../components/pagableComponent/index';

const targetSelector = "#broker-org-details-page";
import SUCCESS_MODAL_TIMEOUT from "../../constants/index.js";
import {doAjax} from "../../utilities/filtersutil";
import { debug, isNull, isNullOrUndefined  } from 'util';

run(targetSelector, ()=>{
    const orgDetailsTemplate =require("./html/orgDetails/orgInfoDetails.html");
    const affiliatedCarriersDetailsTemplate =require("./html/orgDetails/affiliatedCarriersDetails.html");
    const noAffiliatedCarrierTemplate =require("./html/orgDetails/noaffiliatedCarriers.html");
    const teamMembersDetailsTemplate =require("./html/orgDetails/teamMemberDetails.html");
    const noTeamMembersTemplate =require("./html/orgDetails/noTeamMembers.html");
    const historyDetails =require("./html/orgDetails/historySection.html");
    const organizationDetails =$(targetSelector).data("organization-details");  
    const carrierDetails = $(targetSelector).data("carrier-details");
    const teamMembersDetails = $(targetSelector).data("teammember-details");
    const backToList = $(targetSelector).data("back-to-list");
    const brokerOrgEditUrl = $(targetSelector).data("broker-org-edit-url");
    const orgId = $(targetSelector).data("org-id");
    const carrierOrgUrl = $(targetSelector).data('carrier-org-url');


    const datTimeFormat = "MM/DD/YYYY hh:mm A";

    const elementsMap = {
        activestatuspill: ".active-status-pill",
        inactivestatuspill: ".inactive-status-pill",
        activateorgbtn :".activate-org-btn",
        deactivateorgbtn: ".deactivate-org-btn",
        activateteammemberbtn :".activate-org-team-member-btn",
        deactivateteammemberbtn: ".deactivate-org-team-member-btn",
        carrierdetailsmainarea: "#carrier-details-main-area",
        carrierdetailspagingarea: "#carrier-details-paging-area"
        
    };

    const els = {};

    const deactivateOrgURL =   $(targetSelector).data("deactivate-org-url");
    const activateOrg =  $(targetSelector).data("activate-org-msg");
    const deactivateOrg =  $(targetSelector).data("deactivate-org-msg") ;
    let activateDiv = render('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
            activateMsg:  $(targetSelector).data("activate-org-text")
        }
    );

    let deactivateDiv = render('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
        deactivateMsg:  $(targetSelector).data("deactivate-org-text")
        }
    );

    const deactivateTeamMemberURL =   $(targetSelector).data("deactivate-teammember-url");
    const activateTeamMember =  $(targetSelector).data("activate-teammember-msg");
    const deactivateTeamMember =  $(targetSelector).data("deactivate-teammember-msg") ;
    const deactivateBtnTxt =  $(targetSelector).data("deactivate-teammember-btn-text") ;
    const activateBtnTxt =  $(targetSelector).data("activate-teammember-btn-text") ;

    let activateTeamMemberDiv = render('<div class="q-pad-all-xl">{%-activateTeamMemberMsg %}</div>', {
            activateTeamMemberMsg:  $(targetSelector).data("activate-teammember-text")
        }
    );

    let deactivateTeamMemberDiv = render('<div class="q-pad-all-xl">{%-deactivateTeamMemberMsg %}</div>', {
        deactivateTeamMemberMsg:  $(targetSelector).data("deactivate-teammember-text")
        }
    );


    const pageRefreshUrl=$(targetSelector).data("page-refresh-url");
    const loadMoreAffliatedCarriersUrl = $(targetSelector).data("loadmore-afflidated-carriers-url");
    
    const mainEl = $(render(
        require("./html/orgDetails/orgInfoDetails.html"), {
            organizationDetails: organizationDetails,
            orgCreateDateTime : moment(organizationDetails.orgCreatedTime).format(datTimeFormat)+" ET",
            orgModifiedDateTime : moment(organizationDetails.orgModifiedTime).format(datTimeFormat)+" ET",
            orgFormattedPhone: formatPhone(organizationDetails.cmrAddress[0].cadContactCountryPhoneCode+organizationDetails.cmrAddress[0].cadContactPhone),
            teamMembers: getTeamMembers(),
            history: historyDetails,
            orgEditUrl: brokerOrgEditUrl
         }
    ));
    $(targetSelector).append(mainEl);

    function init() {
        setElements();
        setDefaults();
     
    }

    function setElements() {
        setElementsFromScope(els, elementsMap, mainEl);
        els.activateorgbtn.on('click', activateOrganization);
        els.deactivateorgbtn.on('click', deActivateOrganization);
        els.activateteammemberbtn.on('click', activateTeamMembr);
        els.deactivateteammemberbtn.on('click', deActivateTeamMember);
    }

    function setDefaults() {
        if(organizationDetails.orgActive){
            els.activestatuspill.show();
             els.inactivestatuspill.hide();
             els.deactivateorgbtn.show();
             els.activateorgbtn.hide();
        }else{
            els.activestatuspill.hide();
            els.inactivestatuspill.show();
            els.activateorgbtn.show();
            els.deactivateorgbtn.hide();
            
             //disable all team members if organization is inactive
             els.activateteammemberbtn.attr('disabled','disabled');
        }
    }

    function getTeamMembers(){
        if (teamMembersDetails.length > 0) {

            let teamMembersArray = (teamMembersDetails).map((teammember)=>{
                return render(
                    teamMembersDetailsTemplate, {
                    firstname: teammember.firstName,
                    lastname: teammember.lastName,
                    status: teammember.status==0? "Active": "Inactive",
                    email: teammember.emailAddress,
                    username: teammember.userName,
                    phone: formatPhone(teammember.phoneCode+teammember.phoneNumber),
                    userid: teammember.userId,
                    activateUser: teammember.status==0? "q-display-none": "",
                    inactivateUser: teammember.status==0? "": "q-display-none"
                });
            });
        
            return teamMembersArray.join("");
        }else{
            return noTeamMembersTemplate;
        }
      }

    function activateOrganization(e){
           e.preventDefault();  
           let activateOrgModal = new SubmitModalFlow({
               confirmModalTitle: activateOrg,
               confirmModalBody: activateDiv,
               confirmModalBtnText: activateOrg,
               modalDialogClass: "q-modal-dialog-500",
               onConfirmClick: function() {
                  
                       activateOrgModal.showLoadingModal();
                       activateOrg({url: deactivateOrgURL, success: activateSuccess, error: activateFailure});
                       function activateOrg({url, success, error}){
                           $.ajax({
                               data:  {
                                organizationId:orgId,
                                orgType:organizationDetails.orgType,
                                orgRetailerId:organizationDetails.orgRetailerId
                              },
                               url: url,
                               dataType:"JSON",
                               type: 'POST',
                               success: success,
                               error: error
                           });
                       }
                       function activateSuccess(){
                           activateOrgModal.showSuccessModal();
                           setTimeout(function() {
                               location.href=pageRefreshUrl;
                            }, 3000);
                       }
                       function activateFailure(){
                        activateOrgModal.showFailureModal();   
                       }
                   }
             });
             activateOrgModal.init();
             activateOrgModal.showConfirmModal();
       }

       function deActivateOrganization(e){  
            e.preventDefault();  
            let deactivateOrgModal = new SubmitModalFlow({
                confirmModalTitle: deactivateOrg,
                confirmModalBody: deactivateDiv,
                confirmModalBtnText: deactivateOrg,
                modalDialogClass: "q-modal-dialog-500",
                onConfirmClick: function() {
                
                        deactivateOrgModal.showLoadingModal();
                        deactivateOrg({url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure});
                        function deactivateOrg({url, success, error}){
                             $.ajax({
                                data: {
                                    organizationId:orgId,
                                    orgType:organizationDetails.orgType,
                                    orgRetailerId:organizationDetails.orgRetailerId
                                  },
                                url: url,
                                dataType:"JSON",
                                type: 'POST',
                                success: success,
                                error: error
                            });
                        }
                        function deactivateSuccess(){
                            deactivateOrgModal.showSuccessModal();
                            setTimeout(function() {
                                location.href=pageRefreshUrl;
                            }, 3000);
                        }
                        function deactivateFailure(){
                            deactivateOrgModal.showFailureModal();
                        }
                    }
            });
            deactivateOrgModal.init();
            deactivateOrgModal.showConfirmModal();
     }

     function deActivateTeamMember(e){  
        e.preventDefault();  
        let userId = $(this).closest('.deactivate-org-team-member-btn').data('index-id');

        let deactivateTeamMemberModal = new SubmitModalFlow({
            confirmModalTitle: deactivateTeamMember,
            confirmModalBody: deactivateTeamMemberDiv,
            confirmModalBtnText: deactivateBtnTxt,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {
            
                    deactivateTeamMemberModal.showLoadingModal();
                    deactivateTeamMember({url: deactivateTeamMemberURL, success: deactivateSuccess, error: deactivateFailure});
                    function deactivateTeamMember({url, success, error}){
                         $.ajax({
                            data: {
                                userId:userId,
                                status:"false"
                              },
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function deactivateSuccess(){
                        deactivateTeamMemberModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                        }, 3000);
                    }
                    function deactivateFailure(){
                        deactivateTeamMemberModal.showFailureModal();
                    }
                }
        });
        deactivateTeamMemberModal.init();
        deactivateTeamMemberModal.showConfirmModal();
 }
    
 function activateTeamMembr(e){
    e.preventDefault();  
    let userId = $(this).closest('.activate-org-team-member-btn').data('index-id');
    let activateTeamMemberModal = new SubmitModalFlow({
        confirmModalTitle: activateTeamMember,
        confirmModalBody: activateTeamMemberDiv,
        confirmModalBtnText: activateBtnTxt,
        modalDialogClass: "q-modal-dialog-500",
        onConfirmClick: function() {
           
                activateTeamMemberModal.showLoadingModal();
                activateTeamMember({url: deactivateTeamMemberURL, success: activateSuccess, error: activateFailure});
                function activateTeamMember({url, success, error}){
                    $.ajax({
                        data:  {
                            userId:userId,
                            status:"true"
                       },
                        url: url,
                        dataType:"JSON",
                        type: 'POST',
                        success: success,
                        error: error
                    });
                }
                function activateSuccess(){
                    activateTeamMemberModal.showSuccessModal();
                    setTimeout(function() {
                        location.href=pageRefreshUrl;
                     }, 3000);
                }
                function activateFailure(){
                 activateTeamMemberModal.showFailureModal();   
                }
            }
      });
      activateTeamMemberModal.init();
      activateTeamMemberModal.showConfirmModal();
}

   
     init();

 
     const carrierDetailsSection = new PagableComponent({
        dataContainer: $('.carrier-details-main-area'), 
        pagingContainer: $('.carrier-details-paging-area'), 
        data: carrierDetails,
        showData: function(carrier){
        return render(affiliatedCarriersDetailsTemplate, {
            carrierName: !isNullOrUndefined(carrier.orgName)&carrier.orgName!="null"?carrier.orgName:"",
            carrierContactName: !isNullOrUndefined(carrier.carrierContactName)&carrier.carrierContactName!="null"?carrier.carrierContactName:"",
            carrierEmail: !isNullOrUndefined(carrier.carrierContactEmail)&carrier.carrierContactEmail!="null"?carrier.carrierContactEmail:"",
            carrierPhone: !isNullOrUndefined(carrier.carrierPhone)&carrier.carrierPhone!="null"?formatPhone(carrier.carrierPhone):"", 
            carrierScac: !isNullOrUndefined(carrier.carrierScac)&carrier.carrierScac!="null"?carrier.carrierScac:"", 
            carrierGln: !isNullOrUndefined(carrier.carrierGln)&carrier.carrierGln!="null"?carrier.carrierGln:"",
            carrierStatus: !isNullOrUndefined(carrier.orgActive)&carrier.orgActive!="null"?(carrier.orgActive==1? "Active": "Inactive"):"",
            carrierContactEmail: !isNullOrUndefined(carrier.carrierContactEmail)&carrier.carrierContactEmail!="null"?carrier.carrierContactEmail:"", 
            carrierAddress1:!isNullOrUndefined(carrier.carrierAddress1)&carrier.carrierAddress1!="null"?carrier.carrierAddress1:"", 
            carrierAddress2: !isNullOrUndefined(carrier.carrierAddress2)&carrier.carrierAddress2!="null"?carrier.carrierAddress2:"",
            carrierCity: !isNullOrUndefined(carrier.carrierCity)&carrier.carrierCity!="null"?carrier.carrierCity:"", 
            carrierState: !isNullOrUndefined(carrier.carrierState)&carrier.carrierState!="null"?carrier.carrierState:"",
            carrierZipcode: !isNullOrUndefined(carrier.carrierZipcode)&carrier.carrierZipcode!="null"?carrier.carrierZipcode:"",
            carrierCountry: !isNullOrUndefined(carrier.carrierCountry)&carrier.carrierCountry!="null"?carrier.carrierCountry:"",
            carrierOrgId: !isNullOrUndefined(carrier.orgId)&carrier.orgId!="null"?carrier.orgId:""

        });
        },
  
        onFetch: function(page, pageSize){
            carrierDetailsSection.showLoadingOverlay();
          setTimeout(() => {
            doAjax({url: loadMoreAffliatedCarriersUrl, success: loadMoreAffliatedCarriers, error: errorFun,data:prepareDataToSendController(orgId, page, pageSize)});
          },SUCCESS_MODAL_TIMEOUT);
        } 
  
      });
      

      function loadMoreAffliatedCarriers(data){
        let affliatedCarriers = data.content;
        carrierDetailsSection.setData(affliatedCarriers);
        carrierDetailsSection.hideLoadingOverlay();
      }
  
      function errorFun(data){
        carrierDetailsSection.hideLoadingOverlay();
      }

      if (carrierDetails.totalElements >0){
        carrierDetailsSection.init();
      }else{
        $('.carrier-details-main-area').append(render(noAffiliatedCarrierTemplate));
      }

      function prepareDataToSendController(orgId, page, pageSize){
        let data={
          page: page,
          pageSize: pageSize,
          orgId: orgId
        }
        return data;
      }

      $("#backToListBtn").on("click", function() {
        window.open(backToList, "_self");
    });


    $('.carrier-org-details-btn').on("click", function(e) {  
        e.preventDefault();  
        let carrierOrgId = $(this).closest('.carrier-org-details-btn').data('index-id');
        window.open(carrierOrgUrl+'&orgId='+carrierOrgId, '_blank');
    });
  
});


// WEBPACK FOOTER //
// ./src/pages/addressBook/brokerorgdetails.js